<template>
  <v-card>
    <v-toolbar class="py-4" style="background-color:#171717">
      <v-flex v-for="op in operations" :key="op.id">
        <v-layout align-center justify-center column fill-height no-wrap>
          <v-btn style="visibility: hidden" large icon @click="selectAction(op.action)">
            <div style="visibility: visible">
              <!-- <hexagon v-if="!small"/>
              <hexgsm-vue v-if="small"/>-->
              <!-- <v-icon class="hexagon_icon">{{op.icon}}</v-icon> -->
            <p class="pt-3 text-btn blue-hover">
              <ab-toolbar v-if="op.name=='A/B TEST'"/>
              <aoiselection-toolbar v-if="op.name==$t('buttons.aoi')"/>
              <addnew-toolbar v-if="op.name==$t('buttons.add')"/>
              <addfile-toolbar v-if="op.name==$t('buttons.moveTo')"/>
              <download-toolbar v-if="op.name==$t('buttons.download')"/>
              <resize-toolbar v-if="op.name==$t('buttons.size')"/>
              <sort-toolbar v-if="op.name==$t('buttons.sort')"/>
              <delete-toolbar v-if="op.name==$t('buttons.delete')"/>
              {{op.name}}</p>
            </div>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-toolbar>
    <modal-sort-vue/>
    <modal-responsivity-vue/>
    <modal-movedir-vue/>
  </v-card>
</template>
// TODO enlever les titles
<script>
import hexagon from "@/components/icons/hexagon";
import hexgsmVue from "../icons/hexgsm.vue";
import abToolbar from "../icons/tools/ab-toolbar";
import aoiselectionToolbar from "../icons/tools/aoiselection-toolbar";
import addnewToolbar from "../icons/tools/addnew-toolbar";
import addfileToolbar from "../icons/tools/addfile-toolbar";
import downloadToolbar from "../icons/tools/download-toolbar";
import resizeToolbar from "../icons/tools/resize-toolbar";
import sortToolbar from "../icons/tools/sort-toolbar";
import deleteToolbar from "../icons/tools/delete-toolbar";
import modalSortVue from "../modals-form/modal-sort.vue";
import modalResponsivityVue from "../modals-form/modal-responsivity.vue";
import modalMovedirVue from '../modals-form/modal-movedir.vue';
import {mapMutations} from 'vuex';
export default {
  name: "projectOperations",
  components: {
    hexagon,
    hexgsmVue,
    abToolbar,
    aoiselectionToolbar,
    addnewToolbar,
    addfileToolbar,
    downloadToolbar,
    resizeToolbar,
    sortToolbar,
    deleteToolbar,
    modalSortVue,
    modalResponsivityVue,
    modalMovedirVue,
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.$store.dispatch("report/getReports");
  },
  computed: {
    getImgSelected: function() {
      return this.$store.getters["project/getProjectSelected"];
    },
    language() {
      return this.$i18n.locale; 
    }
  },
  watch: {
    language() {
      this.buildOperations();
    }
  },
  beforeMount() {
    this.buildOperations();
  },
  data() {
    return {
      small: true,
      operations: []
    };
  },
  methods: {
    ...mapMutations({
      notif: 'dialogModal/toggleNotif'
    }),
    buildOperations() {
      this.operations = [
        {
          name: this.$t('buttons.aoi'),
          action: "goToAOI",
          icon: "aspect_ratio",
          color: "blue"
        },
        {
          name: this.$t('buttons.download'),
          action: "download",
          icon: "cloud_download",
          color: "blue"
        },
        {
          name: this.$t('buttons.delete'),
          action: "delete",
          icon: "delete",
          color: "blue"
        },
        {
          name: this.$t('buttons.size'),
          action: "sortBySize",
          icon: "photo_size_select_small",
          color: "blue"
        },
        {
          name: this.$t('buttons.sort'),
          action: "sortByName",
          icon: "sort",
          color: "blue"
        },
        {
          name: this.$t('buttons.moveTo'),
          action: "moveToFolder",
          icon: "folder",
          color: "blue"
        },
        {
          name: this.$t('buttons.add'),
          action: "addImage",
          icon: "add",
          color: "blue"
        },
        // {
        //   name: "A/B TEST",
        //   action: "goToAB",
        //   icon: "tab",
        //   color: "blue"
        // },
        
      ]
    },
    async getAllImages() {
      let allImgSelected = this.$store.getters["image/getMultiSelectImg"];
      let allImagesPreview = allImgSelected.map(
        async (uuid) => await this.$store.dispatch("image/getImg", uuid)
      );
      return await Promise.all(allImagesPreview);
    },
    async selectAction(action) {
      switch (action) {
        case "addImage":
          this.addImage();
          break;
        case "delete":
          var imgsToDelete = this.$store.getters['image/getMultiSelectImg']
          if (imgsToDelete.length === 0)
            this.notif([this.$t('titles.youMustSelectImg')]);
          // else this.delete(imgsToDelete);
          else this.$store.commit('image/setModalDelImg', true);
          break;
        case "download":
          var imgsToDelete = this.$store.getters['image/getMultiSelectImg']
          var imgs = await this.getAllImages();
          var noBasic = imgs.find(img => img.saliencyreport.heat_map === null);
          if (imgsToDelete.length === 0)
            this.notif([this.$t('titles.youMustSelectImg')]);
          else if (noBasic)
            this.notif([this.$t('titles.downNoBasic')]);
          else
            this.download(imgsToDelete);
          break;
        case "goToAB":
          this.notif(['Not disponible', 'The "A/B TEST" feature is not complete']);
          break; // Provisoire
          this.goToAB();
          break;
        case "goToAOI":
          var imgs = await this.getAllImages();
          var noBasic = imgs.find(img => img.saliencyreport.heat_map === null);
          if (!this.$store.getters['image/getMultiSelectImg'].length)
            this.notif([this.$t('titles.youMustSelectImg')]);
          else if (noBasic)
            this.notif([this.$t('titles.aoiNoBasic')]);
          else this.goToAOI();
          break;
        case "moveToFolder":
          let imgsToMove = this.$store.getters['image/getMultiSelectImg'];
          if (imgsToMove.length === 0)
            this.notif([this.$t('titles.youMustSelectImg')]);
          else this.moveToFolder(imgsToMove);
          break;
        case "sortByName":
          this.sortByName();
          break;
        case "sortBySize":
          this.sortBySize();
          break;

        default:
          break;
      }
    },
    addImage() {
      // this.$store.dispatch("dialogModal/toggleModalImg");
      let inputFile = document.getElementById('input-file');
      inputFile.click(); 
    },
    delete(imgsToDelete) {
      imgsToDelete.forEach(uuid => {
        this.$store.dispatch("image/deleteMedia", uuid);
      })
      this.$store.commit("image/emptyMultiSelectImg");
    },
    async download(uuidImgs) {
      this.$store.commit('report/setStartDownload', true);
      return // la suite se fait dans le composant itt-download-reports
      let allImgs = await this.$store.getters['image/getImages'];
      // let url = report[0].bundle;
      // const link = document.createElement("a");
      // link.href = url;
      // document.body.appendChild(link);
      // link.click();

      // window.location=file;


    },
    goToAB() {
      
    },
    goToAOI() {
      // let uuid = this.$store.getters["image/getMultiSelectImg"][0];
      this.$router.push({
        path: "/aoi-analyze"
      });
    },
    moveToFolder(imgsToMove) {
      // let selectedProject = this.$store.getters["project/getProjectSelected"];
      // if (selectedProject)
      this.$store.dispatch("dialogModal/toggleMovedir");
    },
    sortByName() {
      
      this.$store.dispatch("dialogModal/toggleSort");
    },
    sortBySize() {
      this.$store.dispatch("dialogModal/toggleResponsivity");
      
    },
    handleResize() {
      let sm = window.matchMedia("(max-width: 700px)");
      let xs = window.matchMedia("(max-width: 399px)");
      if (sm.matches) {
        this.small = true;
      } else {
        this.small = false;
      }
      if (xs.matches) {
        this.xsmall = true;
      } else {
        this.xsmall = false;
      }
    }
  }
};
</script>

<style scoped>
.hexagon_svg {
  position: absolute;
  background: transparent;
  top: -15px;
  left: -1px;
  width: 50px;
  height: 50px;
  transition: 0.4s;
  fill: #424242;
}

.hexagon_icon {
  z-index: 1;
  position: absolute;
  top: -7px;
  left: 12px;
}

.text-btn {
  margin-top: 30px
}
@media (max-width: 700px) {
  .text-btn {
    display: none;
  }
}

.ab,
.aoi,
.new,
.move,
.download,
.size,
.sort,
.delete {
  position: absolute;
  top: -15px;
  left: -5px;
  width: 55px;
}
</style>
